export default __webpack_public_path__ + "static/media/cloud.b03e6d02.png";